import { getEnv } from '@/env';
import { queryURLparams } from '.';

export interface IQuery {
  email: string;
  language: string;
  nickId: string;
  nickName: string;
  sign: string;
  extraInfo: string;
  headIcon: string;
  phone: string;
  source: string;
  groupID: string;
}

let _query = {
  email: '',
  language: '',
  nickId: '',
  nickName: '',
  sign: '',
  extraInfo: '',
  headIcon: '',
  phone: '',
  source: '',
  groupID: '',
};

const tempQuery = queryURLparams<IQuery>();
_query.email = tempQuery?.email || '';
_query.language = tempQuery?.language || '';
_query.nickId = tempQuery?.nickId || '';
_query.nickName = tempQuery?.nickName || '';
_query.sign = tempQuery?.sign || '';
_query.extraInfo = tempQuery?.extraInfo || '';
_query.headIcon = tempQuery?.headIcon || '';
_query.phone = tempQuery?.phone || '';
_query.source = tempQuery?.source || '';
_query.groupID = tempQuery?.groupID || '';

export const query = _query;

export const defaultLang = ['en', 'zh'].includes(query.language) ? query.language : 'en';

export const robotName = 'chat_session_status_14';

export const customerName = 'chat_session_status_1';

let _userDevice = 'web';
/**
 * get device info
 * @returns
 */
const getDevice = () => {
  const userAgent = navigator.userAgent;

  if (/iPhone/i.test(userAgent)) {
    // const match = userAgent.match(/iPhone OS (\d+_\d+)/);
    // if (match) {
    //   return 'iPhone, version: ' + match[1].replace('_', '.');
    // }
    return 'iPhone';
  } else if (/iPad/i.test(userAgent)) {
    return 'iPad';
  } else if (/Macintosh/i.test(userAgent)) {
    return 'Mac';
  } else if (/Windows NT/i.test(userAgent)) {
    return 'Windows';
  } else if (/Android/i.test(userAgent)) {
    // const match = userAgent.match(/Android (\d+\.\d+)/);
    // if (match) {
    //   return 'Android, version: ' + match[1];
    // }
    return 'Android';
  } else {
    return 'Unknown Device';
  }
};

_userDevice = getDevice();

export const userDevice = _userDevice;

let _baseStaticUrl = '';

export const ENV = getEnv(import.meta.env.MODE);

/**
 * 获取静态资源的基本路径
 */
const getBaseStaticUrl = () => {
  const origin = window.location.origin;
  const path = ENV.routerBase;

  return origin + path;
};

_baseStaticUrl = getBaseStaticUrl();

export const baseStaticUrl = _baseStaticUrl; // 静态资源的基本路径
